import { X } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

// Custom Modal Component
export const Modal = ({ isOpen, onClose, title, children }) => {
    const { theme } = useTheme();
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className={`rounded-lg p-6 w-full max-w-md ${
          theme === 'light' ? 'bg-white' : 'bg-gray-800'
        }`}>
          <div className="flex justify-between items-center mb-4">
            <h3 className={`text-lg font-semibold ${
              theme === 'light' ? 'text-gray-900' : 'text-gray-100'
            }`}>{title}</h3>
            <button
              onClick={onClose}
              className={`p-1 rounded ${
                theme === 'light' 
                  ? 'hover:bg-gray-100' 
                  : 'hover:bg-gray-700'
              }`}
            >
              <X className={`w-5 h-5 ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-300'
              }`} />
            </button>
          </div>
          {children}
        </div>
      </div>
    );
  };